import React, { useState } from 'react';
import Select from 'react-select';
import { Badge } from '../ui/badge';
import './styles.css';

const Categories = ({
  title,
  description,
  children,
  isEditing,
  onFieldChange,
  canEdit,
  categories,
  googleProfileInfo,
  additionalCategories = []
}) => {
  const [localValue, setLocalValue] = useState(children);

  // MinusIcon is used for empty fields
  const isMinusIcon =
    children.props?.className?.includes('fas fa-minus') ||
    (typeof children === 'string' && children === 'fas fa-minus');

  const handleInputChange = (e) => {
    const newValue = e.target.value;

    if (isMinusIcon) {
      setLocalValue(localValue);
    }

    if (isEditing && canEdit && !isMinusIcon) {
      setLocalValue(newValue);
      onFieldChange(newValue);
    }
  };

  return (
    <div className="space-y-2 min-w-0">
      <p className="text-sm sm:text-base font-semibold flex items-center gap-2 flex-wrap break-words">
        {title}
      </p>
      {description && (
        <p className="text-sm text-muted-foreground break-words">
          {description}
        </p>
      )}
      <div className="mt-2">
        {isEditing && canEdit && !isMinusIcon ? (
          <>
            <Select
              id="categories"
              options={categories}
              value={categories.find(
                (option) => option.value === googleProfileInfo
              )}
              onChange={async (selectedOption) => {
                console.log('newValue: ', selectedOption);
                setLocalValue(selectedOption);
                onFieldChange(selectedOption);
              }}
              styles={{
                singleValue: (base) => ({
                  ...base,
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '0.875rem'
                })
              }}
            />
          </>
        ) : (
          <div>
            {isEditing && canEdit && isMinusIcon ? (
              <>
                <Select
                  id="categories"
                  options={categories}
                  value={''}
                  onChange={handleInputChange}
                  styles={{
                    singleValue: (base) => ({
                      ...base,
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: '0.875rem'
                    })
                  }}
                />
              </>
            ) : (
              <>
                <div className="flex items-center gap-2 flex-wrap mt-2">
                  {/* Categoría principal - Badge azul (primary) */}
                  {googleProfileInfo && (
                    <Badge className="bg-primary text-primary-foreground">
                      {googleProfileInfo}
                    </Badge>
                  )}

                  {/* Categorías adicionales - Badge gris (secondary) */}
                  {additionalCategories && additionalCategories.length > 0 && (
                    <>
                      {additionalCategories.map((category, index) => (
                        <Badge key={index} variant="secondary">
                          {category.displayName}
                        </Badge>
                      ))}
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Categories;
